<template>
  <div class="feed_back">
    <div>
      <el-form :model="form" ref="form" label-position="top">
        <!--  v-if="`${model.approveCurrentNo}` === '3' || model.type === 'editDone'" :rules="(`${model.approveCurrentNo}` === '3'&&value)  || model.type === 'editDone'? rules.isReturnHq : []" -->
        <el-form-item :label="$t('components_feed_back.yi_fan_zong_bu')" prop="isReturnHq">
          <el-radio-group v-model="form.isReturnHq" :disabled="model.showProcess">
            <el-radio :label="1">{{$t('Common.com_yes')}}</el-radio>
            <el-radio :label="0">{{$t('Common.com_no')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('components_feed_back.shi_fou_jin_shui')" prop="isSoak" :rules="rules.isSoak">
          <custom-select
            v-model="form.isSoak"
            code="isynergy_cloud_bool"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('components_feed_back.gu_zhang_miao_shu')" prop="feedBackDesc" :rules="rules.feedBackDesc">
          <el-input type="textarea" :rows="3" v-model="form.feedBackDesc" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('components_feed_back.ke_fu_chu_li_jie_guo')" prop="handleResultCs" v-if="`${model.approveCurrentNo}` === '3' || model.type === 'editDone'" :rules="(`${model.approveCurrentNo}` === '3'&&value) || model.type === 'editDone' ? rules.handleResultCs : []">
          <el-input :disabled="model.showProcess" type="textarea" :rows="4" v-model="form.handleResultCs" style="width: 100%"></el-input>
          <div class="item-tag">
            <ul class="tag-list">
              <li class="tag" v-for="item in handleResultCsTagList" :key="item.tagName" :class="{ active:item.tagName === form.handleResultCs }" @click="form.handleResultCs=item.tagName">
                <span class="name">{{ item.tagName }}</span>
              </li>
            </ul>
            <el-button class="button-new-tag" @click="addTag(4)">+</el-button>
          </div>
        </el-form-item>
        <el-form-item :label="$t('components_feed_back.yuan_yin_fen_xi')" prop="causeAnalysis" :rules="(`${model.approveCurrentNo}` === '2'&&value) || model.type === 'editDone' ? rules.causeAnalysis : []">
          <el-input :disabled="model.showProcess" type="textarea" :rows="4" v-model="form.causeAnalysis" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('components_feed_back.gai_shan_cuo_shi')" style="position: relative" prop="improveMethod" :rules="(`${model.approveCurrentNo}` === '2'&& value) || model.type === 'editDone'? rules.improveMethod : []">
          <el-input :disabled="model.showProcess" type="textarea" :rows="4" v-model="form.improveMethod" style="width: 100%"></el-input>
          <div class="item-tag">
            <ul class="tag-list">
              <li class="tag" v-for="item in improveMethodTagList" :key="item.tagName" :class="{ active:item.tagName === form.improveMethod }" @click="form.improveMethod=item.tagName">
                <span class="name">{{ item.tagName }}</span>
              </li>
            </ul>
            <el-button class="button-new-tag" @click="addTag(2)">+</el-button>
          </div>
        </el-form-item>
        <el-form-item label="" prop="handleResultQc" style="position: relative" :rules="(`${model.approveCurrentNo}` === '2'&& value) || model.type === 'editDone'&&value ? rules.handleResultQc : []">
          <span slot="label">
            {{ $t('components_feed_back.pzcljg') }}
          </span>
          <el-input :disabled="model.showProcess" type="textarea" :rows="4" v-model="form.handleResultQc" style="width: 100%"></el-input>
          <div class="item-tag">
            <ul class="tag-list">
              <li class="tag" v-for="item in handleResultQcTagList" :key="item.tagName" :class="{ active:item.tagName === form.handleResultQc }" @click="form.handleResultQc=item.tagName">
                <span class="name">{{ item.tagName }}</span>
              </li>
            </ul>
            <el-button class="button-new-tag" @click="addTag(3)">+</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <feed-back-tag-dialog
      v-if="dialogVisible"
      @close="dialogVisible = false"
      :model="dialogModel"
      @success="chooseTag(arguments)"
    ></feed-back-tag-dialog>
    <feed-back-addTag-dialog
      v-if="dialogVisible1"
      @close="dialogVisible1 = false"
      :model="dialogModel1"
      @success="getTagList()"
    ></feed-back-addTag-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import feedBackTagDialog from './children/feed_back_tag_dialog';
import feedBackAddTagDialog from './children/feed_back_addTag_dialog';


export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '', // 新增时为orderId, 编辑查看时为changeId
          approve: false, // 是否是审批页
          approveCurrentNo: '', // 当前审批在哪一步
        };
      },
    },
    value: {
      type: Boolean,
      default() {
        return true;
      },
    }
  },
  components: {
    feedBackTagDialog,
    feedBackAddTagDialog
  },
  data() {
    return {
      orgList: [],
      detail: {},
      // bodyNumList: [],

      form: {
        causeAnalysis: '',
        improveMethod: '',
        handleResultQc: '',
        handleResultCs: '',
        isReturnHq: 0,
        feedBackDesc: '',
        isSoak: '0',
      },
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      improveMethodTagList: [],
      handleResultQcTagList: [],
      handleResultCsTagList: [],
    };
  },
  computed: {
    rules() {
      return {
        causeAnalysis: [
          { required: true, message: this.$t('components_feed_back.qtxyyfx') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
        improveMethod: [
          { required: true, message: this.$t('components_feed_back.qtxgscs'), },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
        handleResultQc: [
          { required: true, message: this.$t('components_feed_back.qtxpzcljg') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
        isReturnHq: [{ required: true, message: this.$t('components_feed_back.qxzyfzb') }],
        handleResultCs: [
          { required: true, message: this.$t('components_feed_back.qtxkfcljg') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
        isSoak: [
          {
            required: true,
            message: this.$t('Common.com_required')
          },
        ],
        feedBackDesc: [
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
          { required: true,
            message: this.$t('Common.com_required')
          }
        ],
      };
    },
    // isSubmit: vm => !vm.bodyNumList.length,
  },
  mounted() {
    this.initDialog();
    this.getTagList();
  },
  methods: {
    getList: function (list) {
      this.orgList = list;
    },

    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        // this.form.orderId = this.model.changeId;
        // this.bodyNumList.push(this.model.row);
      }
      if (this.model.type === 'edit') {
        this.form.applyId = this.model.changeId;
        this.getChangeDetail();
      }
      if (this.model.type === 'watch') {
        this.form.applyId = this.model.changeId;
        this.getChangeDetail();
      }
      if (this.model.type === 'editDone') {
        this.form.applyId = this.model.feedBackId;
        this.getFeedBackDetail();
      }
    },
    getFeedBackDetail: function () {
      this.$getJSON(apis.feedbackInfo, { feedBackId: this.model.feedBackId }).then((res) => {
        this.$setFormatData(this.form, res.data);
      });
    },
    // 获取变更详情
    getChangeDetail: function () {
      this.$getJSON(apis.feedbackInfo, {
        feedBackId: this.model.changeId,
      }).then((res) => {
        this.$setFormatData(this.form, res.data);
        // this.bodyNumList = res.data.applyDeviceList;
      });
    },
    onTagListMore(tagType) {
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('components_feed_back.chang_yong_ci_tiao');
      this.dialogModel.tagType = tagType;
    },
    addTag(tagType) {
      this.dialogVisible1 = true;
      this.dialogModel1.title = this.$t('components_feed_back.xzcyct');
      this.dialogModel1.tagType = tagType;
    },

    getTagList() {
      this.$getJSON(apis.feedbackTagList, {
        // tagType: '2,3,4'
        // 标签类型，2-改善措施，3-处理结果（客服），4-处理结果（品质）
      }).then((res) => {
        this.improveMethodTagList = res.data.filter(i => `${i.tagType}` === '2');
        this.handleResultQcTagList = res.data.filter(i => `${i.tagType}` === '3');
        this.handleResultCsTagList = res.data.filter(i => `${i.tagType}` === '4');
      });
    },
    chooseTag(arg) {
      // tagName, tagType, isRefresh
      const { tagName, tagType, isRefresh } = arg[0];
      if (`${tagType}` === '2') {
        this.form.improveMethod = tagName;
      } else if (`${tagType}` === '3') {
        this.form.handleResultQc = tagName;
      } else if (`${tagType}` === '4') {
        this.form.handleResultQc = tagName;
      }
      if (isRefresh) {
        this.getTagList();
      }
    },
    // 确认保存
    onConfirm: function () {
      if (this.model.type === 'watch' && !this.model.approve) {
        this.$emit('close');
        return '';
      } else {
        return this.$refs.form.validate();
      }
      // return new Promise(function (resolve, reject) {
      //   this.$refs.form.validate((valid) => {
      //     if (!valid) {
      //       reject()
      //       return;
      //     }
      //     resolve();
      //     this.$emit('success');
      //   });
      // });
    },
  },
};
</script>

<style lang="scss">
.feed_back {

  .item-tag {
    margin-top: 5px;
          height: 40px;
          line-height: 40px;
          display: flex;
          align-items: center;
          // position: absolute;
          // bottom: 0;
          // width: 100%;
          // padding: 0 20px;
          // max-width: 520px;
          // overflow: auto;
          .lable {
            align-items: center;
            font-weight: bold;
            font-size: 14px;
            line-height: 140%;
            color: #4D4D4D;
            margin-right: 8px;
          }
          .tag-list {
            display: flex;
            flex-direction: row;
            align-items: center;
            flex: 1;
            overflow-x: auto;
            margin-right: 8px;
            .tag {
              height: 30px;
              color: #1a1a1a;
              background: #f8f8f8;
              padding: 0 16px;
              background: #f8f8f8;
              line-height: 30px;
              margin-right: 8px;
              border-radius: 100px;
              cursor: pointer;
              flex: none;
              .name {
                margin-right: 4px;
              }
              .icon {
                font-size: 12px;
                color:#00A0D9;
                margin-left: 11px;
              }

              &.active {
                color: #ffffff;
                background:#00A0D9;
              }
            }
          }

          .icon-shezhi,
          .icon-guanbi1,
          .icon-tianjia {
            width: 40px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 12px;
            color: #202945;
            border-radius: 100px;
            background-color: #FFAD00;
            margin-right: 8px;
            cursor: pointer;
          }
          .icon-tianjia {
            color:#00A0D9;
            background-color: #f8f8f8;
          }
        }
}
</style>
